/**
 * Common LIQUIDO PWA configuration that is used in all environments.
 * This file is merged into the environment specific configs.
 * 
 * This is different from plain vue environment variables that can be set via .env.production files.
 * https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
 * 
 * LIQUIDO Config is "statically" imported into the scripts.
 */

export default {
	configSource: "common",
	BASE_URL: "/",                   				// Used for loading JS libs in browser. MUST end with '/'
	LIQUIDO_API_URL: undefined,  						// MUST set this in your env config
	showDebugLog: false,
	mockBackend: false,
	mockPasskey: false,											// DEV only: skip the real WebAuthn browser ceremony (see src/polly/services/polly-passkey.js)

	// ============ Validation rules and limits shared with the backend ============
	//
	// These are FALLBACKS only, used until the real values are fetched from the backend's
	// `query liquidoConfig` at startup (see root-app.vue's loadLiquidoConfig()) and merged in via
	// Object.assign. Keep them equal to LiquidoConfig's @WithDefault values in the backend, so an
	// unreachable backend degrades to the same rules the server actually enforces. This file is NOT
	// the source of truth - it had already drifted once: proposalDescriptionMinLength read 10 here
	// while the backend enforced @Size(min=20), so a 12-character description passed the client and
	// was then rejected by the server.
	//TODO: implement these settings per Team! in the backend!
	usernameMinLength: 3,
	inviteCodeLength: 8,			       				// used for validating inviteCodes in welcome-chat.vue
	minPasswordLength: 10, 									// used in forgot-password.vue
	allowMembersToInvite: true,
	pollTitleMinLength: 5,
	pollDefaultRuntimeDays: 7,								// the start page preselects an end this many days ahead, see poll-start.vue
	minVotingMinutes: 540,									// the shortest voting phase the backend accepts (LiquidoConfig.minVotingMinutes)
	maxVotingDays: 365,										// the longest voting phase the backend accepts (LiquidoConfig.maxVotingDays)
	votingEndEarliestHour: 9,								// the earliest end the start page offers: tomorrow at 09:00 local time
	proposalTitleMinLength: 3,
	proposalDescriptionMinLength: 20,				// MUST match the backend's ProposalEntity.description @Size(min=20)
	avatarPath: "./img/avatars",
	inviteLinkPrefix: "http://app.liquido.vote/welcome?inviteCode=",
	// The two apps' own addresses, for the links from one to the other - a Polly user going on to LIQUIDO, a
	// LIQUIDO user to their pollys. Every environment sets its own. A polly's share link needs neither: it is the
	// Polly app's own origin (polly-client.js, shareLinkFor).
	liquidoAppUrl: "https://app.liquido.vote",
	pollyAppUrl: "https://polly.liquido.vote",
	pollyNameMaxLength: 40,									// longest (nick)name of a polly's creator or voter
	pictureMaxBytes: 200000,								// largest profile picture upload (LiquidoConfig.pictureMaxBytes)
	pictureSize: 256,										// a profile picture is scaled to this square before it is uploaded
	pictureMaxFileBytes: 20000000,							// largest file a user may choose as their picture; it is scaled down before the upload. A recent iPhone photo can be that big
	//TODO: adminMustConfirmNewMembers: ...
	//TODO: voting algorith: absoluteMajority or margin

	// Development logins. `token` is the dev-login token the client sends with devLogin, newestSeedTeam
	// and devLoginPolly; a real backend checks it against its own liquido.dev-login-token. The mock backend
	// only checks it for newestSeedTeam, and has no devLoginPolly. `mockSmsToken` is the SMS code the mock
	// accepts. teamName, member and admin are left over from the mock's old seed: login-via-sms.vue still
	// prefills admin.mobilephone, which no user in teamsSeed.json has.
	devLogin: {
		teamName: "DevLogin Team",
		token: "XXXXX_DevLoginToken",
		mockSmsToken: "123456",
		member: {
			name: "DevLogin Member",
			email: "membr47113@liquido.vote",
			mobilephone: "01515551754552747221",

		},
		admin: {
			name: "TestAdmin 4711",
			email: "testadmin4711@liquido.vote",
			mobilephone: "01515554711"
		}
	}

}